var map = {
	"./browser.svg": 160,
	"./caret-down.svg": 161,
	"./caret-left.svg": 162,
	"./caret-right.svg": 163,
	"./caret-up.svg": 164,
	"./ear-left.svg": 165,
	"./ear-right.svg": 166,
	"./favicon-big-eyes.svg": 167,
	"./favicon-holy.svg": 168,
	"./favicon-robot.svg": 169,
	"./favicon.svg": 170,
	"./github.svg": 171,
	"./lightning.svg": 172,
	"./location.svg": 173,
	"./me.svg": 19,
	"./micropone.svg": 174,
	"./mouse.svg": 20,
	"./poes-chrome.svg": 21,
	"./poes-edge.svg": 22,
	"./poes-firefox.svg": 23,
	"./poes-safari.svg": 24,
	"./twitter.svg": 175,
	"./whisker-left.svg": 176,
	"./whisker-right.svg": 177
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 178;


//////////////////
// WEBPACK FOOTER
// ./src/icons ^\.\/.*\.svg$
// module id = 178
// module chunks = 0